import React from "react";
import { makeStyles } from "@material-ui/core";
import { Searchbar } from "../Shared/Searchbar/Searchbar";
import { Filter } from "../Shared/Searchbar/Filter";
import HelperTooltip from "../Shared/HelperTooltip/HelperTooltip";

const useEnhancedToolbarActionsStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "flex-end"
  },
  actionIcon: {
    margin: "0 2px 0 2px"
  }
}));

export const EnhancedToolbarActions = ({
  onSearch,
  onClear,
  searchTerm,
  setFilters,
  filters,
  tableName
}) => {
  const classes = useEnhancedToolbarActionsStyles();

  return (
    <div className={classes.root}>
      <Searchbar
        table={tableName}
        className={classes.actionIcon}
        onSearch={onSearch}
        onClear={onClear}
        searchTerm={searchTerm}
      />
      <HelperTooltip
        tooltipText={"To search for multiple terms, separate with a comma"}
      />
      <Filter setFilters={setFilters} filters={filters} />
    </div>
  );
};
